export default {
  "icon": "_icon_1rpnjp_3",
  "sizeS": "_sizeS_1rpnjp_7",
  "sizeM": "_sizeM_1rpnjp_12",
  "sizeL": "_sizeL_1rpnjp_17",
  "light": "_light_1rpnjp_22",
  "dark": "_dark_1rpnjp_26"
};
//# sourceMappingURL=index.css.js.map